module.exports = __webpack_public_path__ + "static/media/법인전환.a9d44860.png";